import React from 'react';
import { useQuery } from '@apollo/client';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useAuth } from '~/context/auth';
import { NO_PAG_LIST_OFFSET } from '~/data/constants';
import { ModuleInstanceResult } from '~/data/models/yearbook';
import { GROUP_SAMPLE } from '~/data/operations/group';
import { MODULE_INSTANCE_RESULTS } from '~/data/operations/yearbook';
import { ModuleType } from '~/data/types/graphql';
import { RootStackParamList, YearbookStackParamList } from '~/navigation/types';
import CollectedDataLayout from './layout';

type CollectedDataNavProp = CompositeNavigationProp<
  StackNavigationProp<YearbookStackParamList, 'CollectedData'>,
  StackNavigationProp<RootStackParamList>
>;

export default function CollectedData(): JSX.Element {
  const navigation = useNavigation<CollectedDataNavProp>();

  const { authGroupId, authUserId } = useAuth();

  const { data: groupData } = useQuery(GROUP_SAMPLE, {
    variables: {
      id: authGroupId,
    },
  });

  const groupSample = groupData?.group;

  const { data: moduleInstancesData, loading } = useQuery(
    MODULE_INSTANCE_RESULTS,
    {
      variables: { group: authGroupId, first: NO_PAG_LIST_OFFSET },
    },
  );

  const moduleInstanceResults: ModuleInstanceResult[] =
    (moduleInstancesData?.moduleInstances?.edges.map(
      (edge) => edge?.node,
    ) as ModuleInstanceResult[]) || [];

  const openBannersInBrowser = (url: string) => {
    navigation.navigate('Browser', {
      title: 'Banner',
      url,
    });
  };

  return (
    <CollectedDataLayout
      loading={loading}
      moduleInstanceResults={moduleInstanceResults}
      usersTotal={groupSample?.usersCount || 0}
      onBack={() => navigation.goBack()}
      authUserId={authUserId}
      openBannersInBrowser={openBannersInBrowser}
      onSelectModule={(type, moduleInstanceId) => {
        if (type === ModuleType.PROFILE_PAGE) {
          navigation.navigate('ProfilePageResults', { moduleInstanceId });
        } else if (type === ModuleType.QUOTES) {
          navigation.navigate('Quotes', { moduleInstanceId, viewOnly: true });
        } else if (type === ModuleType.COLLAGES) {
          navigation.navigate('Collages', { moduleInstanceId, viewOnly: true });
        } else if (type === ModuleType.REPORTS) {
          navigation.navigate('Reports', { moduleInstanceId, viewOnly: true });
        } else if (type === ModuleType.RANKINGS) {
          navigation.navigate('Rankings', { moduleInstanceId, viewOnly: true });
        } else if (type === ModuleType.CUSTOM_PAGES) {
          navigation.navigate('CustomPageResults', {
            moduleInstanceId,
          });
        }
      }}
    />
  );
}
